import React, { useEffect } from 'react';
import { clearAuthToken } from '../../utils/authTokenStorage';

const AuthCallback = () => {
  useEffect(() => {
    const handleCallback = () => {
      // Remove any legacy hash token and stale browser storage entries.
      if (window.location.hash) {
        window.history.replaceState(null, '', window.location.pathname);
      }
      clearAuthToken();

      const redirectPath = localStorage.getItem('redirect_after_login');
      localStorage.removeItem('redirect_after_login');
      const safeRedirectPath = redirectPath && redirectPath.startsWith('/') ? redirectPath : '/draw';

      // Full reload so AuthContext re-checks cookie-backed authentication.
      window.location.href = safeRedirectPath;
    };

    handleCallback();
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-loading">
          <div className="spinner"></div>
          <p>Completing authentication...</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
